// extracted by mini-css-extract-plugin
module.exports =  {"nav-tab-button-container":"nav-tab-button-container-dYhs0","label":"label-BCz2f","icon":"icon-TzPrK","logo":"logo-xJBE9"};